import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';

// Whether the reframed Edward Jones distribution-partner experience is active for the current
// advisor. When on: connecting a partner is a factual "who I work with" election rather than a
// sharing directive, existing clients are never auto-shared (only future ones, or per-client via
// Share with Supervisor), and the "Acknowledge" step becomes a "Connect" election with disclosure
// language. Nothing changes for advisors without this flag.
export function useIsDistributionPartnersForEdj(): boolean {
  const { flags } = useFeatureFlags();

  return flags.distributionPartnersForEdj === true;
}
